<template>
    <div class="container">
        <h2 class="section_title">Nossos Planos</h2>
        <div class="row text-center">
            <div class="selector">
                <p class="subtitle">Quantos anúncios você deseja publicar no WebQuarto?</p>
                <select class="form-control" v-model="selected" name="" @change="planSelected()">
                    <option value="">Selecione a quantidade de anúncios</option>
                    <option v-bind:value="index" v-for="(pl, index) in plans" v-bind:key="index">Até {{ pl.max_ads }} anúncios</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-4 bl_cnt" v-for="(index) in trio" :key="index">
                <div class="price_block">
                    <h3>Plano Profissional <span>Até {{ plans[index].max_ads }} anúncios</span></h3>
                    <div class="details">
                        <p><img src="/images/subscription-landing/checkbox-planos.svg" alt=""> Todas as vantagens da assinatura Premium</p>
                        <p><img src="/images/subscription-landing/checkbox-planos.svg" alt=""> Você pode criar até {{ plans[index].max_ads }} anúncios no WebQuarto</p>
                        <p><img src="/images/subscription-landing/checkbox-planos.svg" alt=""> E muito mais...</p>
                    </div>
                    <div class="price">
                        <p class="big"><span class="val">R$ {{ pricePerAd(plans[index]) }}</span> por anúncio</p>
                        <p class="small">R$ {{ plans[index].price }} por mês</p>
                    </div>
                    <div class="subscribe text-center">
                        <button class="btn btn-success btn-lg w-lg waves-effect waves-light" @click="startCheckout(index)">Assinar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['auth', 'api_key'],
    data() {
        return {
            plans: [],
            selected: 0,
            trio: [],
        };
    },
    methods: {
        getPlans() {
            axios.get('/subscription/plans').then((res) => {
                this.plans = res.data;
                this.trio = [0,1,2];
            })
        },
        planSelected() {
            this.trio = [this.selected];

            if (this.selected == 0) {
                this.trio.push(1,2);
            } else if (this.selected == this.plans.length - 1) {
                this.trio.push(this.selected - 2, this.selected - 1);
            } else {
                this.trio.push(this.selected - 1, this.selected + 1);
            }

            this.trio.sort((a, b) => {
                return a - b;
            });
        },
        pricePerAd(plan) {
            return (plan.price / plan.max_ads).toFixed(2).replace('.', ',');
        },
        startCheckout (index) {
            if (!this.auth) {
                EventBus.$emit('open-modal', 'login-modal');
                return;
            }

            axios.post('/subscription/start-session', {price_id: this.plans[index].stripe_id}).then(res => {
                let response = res.data;
                if (typeof response.session_id != 'undefined') {
                    var stripe = Stripe(this.api_key);
                    stripe.redirectToCheckout({sessionId: response.session_id}).then((str) => {
                        console.log(str);
                    });
                }
            });
        },
    },
    created() {
        this.getPlans();
    }
}
</script>
